/* eslint-disable react/jsx-no-bind */
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import css from './ImageGallery.APP_TARGET.scss';
import classNames from 'classnames';
import { getImg } from 'Helpers/images';
import { noop } from 'Helpers/function';
import cx from 'classnames';

const IMG_RATIO = 4 / 3; // eslint-disable-line
const COEFF_MULTIPLE = 1.5;
const OFFSET_Y = 50;

export const GalleryContent = ({ image, title, imageHeight, imageSize, enableZoom, isActive, disableImgOptimization, stretchImage, adpvTxnRevamp }) => {
    const { relation, url, srcset } = getImg({
        image,
        width: imageSize,
        height: imageHeight,
        disableImgOptimization });

    const [isZoomedIn, setIsZoomedIn] = useState(false);
    const [clientX, setClientX] = useState(0);
    const [clientY, setClientY] = useState(0);

    // image data
    const imageEl = useRef(null);
    const imageDimensions = useRef({});
    const imageCanvasDimensions = useRef({});

    // calculate rendered dimensions

    const onImageLoad = () => {
        const { naturalWidth, naturalHeight, parentNode: imageCanvas } = imageEl.current;

        imageDimensions.current.naturalWidth = naturalWidth;
        imageDimensions.current.naturalHeight = naturalHeight;
        imageDimensions.current.naturalRatio = naturalWidth / naturalHeight;

        imageCanvasDimensions.current.width = imageCanvas.offsetWidth;
        imageCanvasDimensions.current.height = imageCanvas.offsetHeight;

        imageDimensions.current.zoomedWidth = imageCanvasDimensions.current.width * COEFF_MULTIPLE;
        imageDimensions.current.zoomedHeight = imageDimensions.current.zoomedWidth / imageDimensions.current.naturalRatio;
    };

    const handleZoom = event => {
        const { zoomedWidth, zoomedHeight } = imageDimensions.current;
        const { width: canvasWidth, height: canvasHeight } = imageCanvasDimensions.current;

        const rect = event.target.getBoundingClientRect();

        const eventClientX = (event.clientX - rect.left);
        const eventClientY = (event.clientY - rect.top);

        const zoomClientX = eventClientX * (zoomedWidth / canvasWidth);
        const zoomClientY = eventClientY * (zoomedHeight / canvasHeight) - OFFSET_Y;

        let calClientX = -zoomClientX;
        let calClientY = -zoomClientY;

        const minLimitX = zoomedWidth - canvasWidth;
        const minLimitY = zoomedHeight - canvasHeight;

        if (calClientX > 0) {
            calClientX = 0;
        }
        else if (calClientX < -minLimitX) {
            calClientX = -minLimitX;
        }
        if (calClientY > 0) {
            calClientY = 0;
        }
        else if (calClientY < -minLimitY) {
            calClientY = -minLimitY;
        }
        setClientX(calClientX);
        setClientY(calClientY);
    };

    const onZoomInClick = event => {
        handleZoom(event);
        setIsZoomedIn(true);
    };
    const onZoomOutClick = () => {
        setIsZoomedIn(false);
    };

    let imgProps = {
        key: 'defaultImg',
        onMouseDown: enableZoom ? onZoomInClick : noop,
        onLoad: onImageLoad,
        className: classNames(
            {
                [css.width]: relation > IMG_RATIO,
                [css.height]: relation <= IMG_RATIO,
                [css.zoomInPointer]: enableZoom,
                [css.zoomImgCanvas]: enableZoom
            }
        ),
        'data-aut-id': 'defaultImg',
        srcSet: srcset
    };

    if (enableZoom && isZoomedIn && isActive) {
        imgProps = {
            key: 'zoomImg',
            onMouseDown: onZoomOutClick,
            onMouseMove: handleZoom,
            className: css.zoomedImg,
            'data-aut-id': 'zoomedImg',
            style: {
                objectPosition: `${Number.isNaN(clientX) ? 0 : clientX}px ${Number.isNaN(clientY) ? 0 : clientY}px`,
                width: `${imageDimensions.current.zoomedWidth}px`,
                height: `${imageDimensions.current.zoomedHeight}px`
            }
        };
    }

    return (
        <div className={ css.slides }>
            <figure>
                {url ? (
                    <img
                        ref={ imageEl }
                        title={ title }
                        alt={ title }
                        src={ url }
                        { ...imgProps }
                        className={ cx({ [css.stretch]: stretchImage }) }
                    />
                ) : (
                    <div className={ css.iframeBlock }>
                        <div className={ adpvTxnRevamp ? css.iframeContainerRevamp : css.iframeContainerOld }>
                            <iframe
                                allowFullScreen
                                title={ title }
                                className={ adpvTxnRevamp ? css.iframeVideoRevamp : css.iframeVideoOld }
                                src={ `https://geo.dailymotion.com/player/${image.external_id}.html?video=${image.id}` }
                            />
                        </div>
                    </div>
                )}
            </figure>
        </div>
    );
};

GalleryContent.propTypes = {
    image: PropTypes.object.isRequired,
    title: PropTypes.string,
    imageSize: PropTypes.string.isRequired,
    imageHeight: PropTypes.string,
    enableZoom: PropTypes.bool,
    isActive: PropTypes.bool,
    disableImgOptimization: PropTypes.bool,
    stretchImage: PropTypes.bool,
    adpvTxnRevamp: PropTypes.bool
};

GalleryContent.defaultProps = {
    title: '',
    imageSize: '400',
    enableZoom: false,
    isActive: false
};

export default GalleryContent;

